import { useI18n } from "i18n";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { BROWSER_NAMES, SUPPORT_STATUS } from "modules/systemCheck/constants";
import { BrowserSupport } from "modules/systemCheck/types";
import { DetectionTestBase } from "../DetectionTestBase";

interface Props {
  browser: BROWSER_NAMES;
  browserSupport: BrowserSupport;
  hasDivider?: boolean;
}

const getErrorName = (status: SUPPORT_STATUS) => {
  if (status === SUPPORT_STATUS.SUPPORTED) {
    return "micCamCheck:browser";
  }

  return "micCamCheck:browser.not.supported";
};

const getErrorMessage = (status: SUPPORT_STATUS) => {
  if (status === SUPPORT_STATUS.SUPPORTED) {
    return "micCamCheck:browser.supported";
  }

  return "micCamCheck:browser.not.supported.message";
};

export const BrowserDetection = ({
  browser,
  browserSupport,
  hasDivider = true,
}: Props): JSX.Element => {
  const { t } = useI18n(["micCamCheck", "url"]);

  return (
    <DetectionTestBase
      testName={t(getErrorName(browserSupport.status))}
      testResult={
        <Typography variant="body1">
          {`${t(getErrorMessage(browserSupport.status))} \n(${browser})`}
        </Typography>
      }
      troubleShootLink={t("url:supported.os.browsers")}
      showTroubleshootLink={browserSupport.status !== SUPPORT_STATUS.SUPPORTED}
      isRecommendation
      hasDivider={hasDivider}
    />
  );
};
